import { toggleBooleanAttribute } from "../utilities/attributes";

//@ts-check
const tabBlocks = document.querySelectorAll('[data-tabs]');
if (tabBlocks.length) {
    tabBlocks.forEach(tabBlock => {
        const tabLinks = tabBlock.querySelectorAll('.tab-links .tab-link');
        const tabSections = tabBlock.querySelectorAll('.tab-content .tab-pane');
        const locationSelect = tabBlock.querySelector('select'); // Get dropdown

        // Event listeners
        tabLinks.forEach(tabLink => {
            tabLink.addEventListener('click', e => handleTabChange(e, tabLink));
        });

        if (locationSelect) {
            locationSelect.addEventListener('change', e => {
                const selectedOption = e.target.value;
                const correspondingTab = tabBlock.querySelector(`#tab-title-${selectedOption}`);
                if (correspondingTab) {
                    handleTabChange(null, correspondingTab);
                }
            });
        }

        function handleTabChange(e, trigger) {
            if (e) e.preventDefault();

            const tabId = trigger.querySelector('a')?.getAttribute('href') ||
                `#tab-${trigger.getAttribute('id').replace('tab-title-', '')}`;

            // Update tab links
            tabLinks.forEach(tabLink => {
                if (tabLink.querySelector('a')?.getAttribute('href') !== tabId) {
                    tabLink.classList.remove('active');
                } else {
                    tabLink.classList.add('active'); // Changed from toggle to add
                }
            });

            // Update tab sections
            tabSections.forEach(tabSection => {
                const tabTarget = tabId.replace('#', '');
                if (tabSection.getAttribute('id') !== tabTarget) {
                    tabSection.classList.remove('active');
                    tabSection.setAttribute('aria-hidden', 'true');
                } else {
                    tabSection.classList.add('active'); // Changed from toggle to add
                    tabSection.setAttribute('aria-hidden', 'false');
                }
            });

            // Update dropdown if it exists
            if (locationSelect) {
                locationSelect.value = tabId.replace('#tab-', '');
            }
        }
    });
}